import { ApiBase } from '@/api/api'
import { makePatchRequest } from '@/api/fetchCalls'
import { CustomerModel, CustomerResponseModel } from '@/domain/model/customer'

export const updateCustomerById = async (
  data?: Partial<CustomerModel>
): Promise<CustomerResponseModel | void> => {
  if (!data) return Promise.resolve()
  return await makePatchRequest(ApiBase + `/customers/${data.id}`, {
    body: { ...data, id: undefined },
  })
}
